import { useTelemetryStore, type ActiveCall } from '../../stores/telemetryStore'
import { phonesMatch } from '../../lib/utils'

export function useActiveCallForPhone(phoneNumber: string): ActiveCall | undefined {
  const activeCalls = useTelemetryStore((state) => state.activeCalls)
  return Object.values(activeCalls).find(
    (call) =>
      call.status !== 'ended' &&
      (phonesMatch(call.from_number, phoneNumber) || phonesMatch(call.to_number, phoneNumber)),
  )
}
